import {camelCaseObject} from '../utils'



export function setSpotifyCredentials(credentials) {
  return dispatch => {
    dispatch({type: 'SET_SPOTIFY_AUTHORIZATION_CREDENTIALS', payload: camelCaseObject(credentials)})
  }
}